<template>
  <div class="pb-8">
    <span v-if="userData">
<v-alert type="success">
  <h2 class="text-white">Sie sind jetzt eingeloggt.</h2>
</v-alert>
    </span>
    <span v-if="!userData">
    <v-row v-if="showClose"
          ><v-col cols="10"></v-col
          ><v-col cols="2"
            ><v-btn icon @click="userStore.closeLogin">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-col
          ></v-row
        >
        <div v-if="!showPassVergessen">
          <template v-if="!compactMode">
            <h2 class="mb-2">Team<span class="text-blue">Waizmann</span>  |  Login</h2>
            Melden Sie sich einfach mit Ihren <b>WaizmannTabelle</b> Zugangsdaten
            an. Wenn Sie Ihr Passwort vergessen haben, klicken Sie bitte auf
            "Passwort vergessen".<br />
            <b>Sie haben noch keinen Zugang? <router-link @click="userStore.setLoginView(false)" to="/login">Jetzt kostenlos anmelden....</router-link></b>
            <br /><br />
          </template>

          <span v-if="showSocialLogin">
  <v-row  v-if="!isLoggedIn" class="mt-2">
        <v-col cols="12" md="6">
          <v-btn
    color="#DB4437" 
    @click="loginWithGoogle"
    class="text-center white--text"
    block
    justify="center"
  >
    <v-icon class="mr-2">mdi-google</v-icon>
    Mit Google anmelden
  </v-btn>
  
        </v-col>
 
        <v-col cols="12" md="6" v-if="showFacebookLogin">
          <v-btn
            color="primary"
            @click="loginWithFacebook"
           
            block
            variant="elevated"
          >
            <template v-slot:prepend>
              <v-icon>mdi-facebook</v-icon>
            </template>
            Mit Facebook anmelden
          </v-btn>
        </v-col>
      </v-row>
  <v-row class="my-4">
    <v-col cols="12" md="12">
      <div class="divider-container">
      <v-divider></v-divider>
      <span class="divider-text"><b>oder</b></span>
      <v-divider></v-divider>
    </div>
    </v-col>
  </v-row>
  </span>
          <v-form ref="form" @submit.prevent="startLogin">
 
            <v-text-field
              v-model="userLogin.user_email"
              :error-messages="emailError"
              @blur="validateUserEmail"
              @input="validateForm"
              label="E-Mail"
              type="email"
              required
            ></v-text-field>
    
                          <v-text-field
                            v-model="userLogin.user_password"
                            label="Passwort"
                            :type="showPassword ? 'text' : 'password'"
                            append-icon="mdi-eye"
                            @click:append="toggleShowPassword"
                            @input="validateForm"
                            required
                          ></v-text-field>
          
            <v-row v-if="showFormError">
             
              <v-col cols="12" class="my-2" >
                <ul class="ml-8">
                  <li v-for="error in formErrors" :key="error">
                    <span v-if="error" class="error">{{ error }}</span>
                  </li>
                </ul>
              </v-col>
            </v-row>
          
            <v-btn type="submit" color="primary"
            
              >TeamWaizmann | WaizmannTabelle Login</v-btn
            >
            <v-btn
              class="ml-12"
              @click="showPassVergessen = !showPassVergessen"
              :color="showPassVergessen ? 'primary' : ''"
              >Passwort vergessen</v-btn
            >
            
          </v-form>
        </div>
        <div v-if="showPassVergessen">
          <h2>Passwort zusenden</h2>
          <v-form ref="form" @submit.prevent="startPasswortVergessen">
            <v-text-field
              v-model="userLogin.user_email"
              :error-messages="emailError"
              @blur="validateUserEmail"
              @input="validateForm"
              label="E-Mail"
              type="email"
              style="font-size: 18px;"
              required
            ></v-text-field>

            <span v-if="formErrors.email" class="error">{{ formErrors.email }}</span>

            <v-btn type="submit"  color="primary"
              >Passwort per E-Mail zusenden</v-btn
            >

            <v-btn
              class="ml-4"
              :color="!showPassVergessen ? 'primary' : ''"
              @click="showPassVergessen = !showPassVergessen"
              >zurück zum Login</v-btn
            >
            <v-row v-if="showFormErrorVergessen">
             
             <v-col cols="12" class="my-2" >
               <ul class="ml-8">
                <li v-for="error in formErrors" :key="error">
                  <span v-if="error" class="error">{{ error }}</span>
                </li>
              </ul>
            </v-col>
          </v-row>
        


          </v-form>
        </div>
      </span>
  </div>
</template>

<script setup>
import {  ref, inject, watch, defineProps, onMounted } from "vue";
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/stores/userStore';
import regexHelper from '@/plugins/regexHelper';
import { useRouter } from 'vue-router'; // Fehlender Import könnte Probleme verursachen
const router = useRouter();
const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore')
const errorStore = inject('errorStore')
const successStore = inject('successStore');
const userStore = useUserStore();
const showClose = ref(false);
const isLoggedIn = ref(false);
const showPassVergessen = ref(false);
const showSocialLogin = ref(false);
const showFacebookLogin = ref(true);
const userLogin = ref({
  user_email: '',
  user_password: '',
  action: 'startlogin',
});
const { userData } = storeToRefs(userStore)
const showPassword = ref(false);
const emailError = ref('');
const form = ref(null);
const submitStarted = ref(false);

const props = defineProps({
     newRoute: {
       type: [String]
     },
     prefillEmail: {
       type: String,
       default: ''
     },
     compactMode: {
       type: Boolean,
       default: false
     },
     initialForgotPassword: {
       type: Boolean,
       default: false
     }
   });
   /* global google */
console.log(props.newRoute);

watch(() => props.prefillEmail, (email) => {
  if (email) {
    userLogin.value.user_email = email;
  }
}, { immediate: true });
// Watcher für die E-Mail-Adresse
watch(() => userLogin.value.user_email, (newEmail) => {
  // Überprüfe, ob die E-Mail gültig ist, während der Benutzer tippt
  if (newEmail && regexHelper.validateEmail(newEmail) === true) {
    // Wenn die E-Mail gültig ist, setze den Fehler zurück
    emailError.value = '';
  }
  // Bei ungültiger E-Mail machen wir nichts - der Fehler wird erst bei @blur angezeigt
});


async function countSocialLogins(what) {
  // Formular validieren
  let data = {
    what: what,
    action: 'countSocialLogins'
  }
  baseCalls.userPost(data);

  // Prüfen, ob es Fehler gibt
  
}

const toggleShowPassword = () => {
  showPassword.value = !showPassword.value;
};

function validateUserEmail() {
   const [showError, textError] = regexHelper.validateEmail(userLogin.value.user_email);

  if (showError === false) {
    // E-Mail ist gültig
    emailError.value = '';
    return true;
  } else {
    // E-Mail ist ungültig, validationResult enthält die Fehlermeldung
    emailError.value = textError;
    return false;
  }
}


const showFormError = ref(false)
const showFormErrorVergessen = ref(false)
// Fehlerobjekt
const formErrors = ref([])

function validateFormVergessen() {
  // Validierung der Eingabefelder
  formErrors.value = [];
  const [showError, textError] = regexHelper.validateEmail(userLogin.value.user_email)
  
  if (showError) {
    formErrors.value.push(textError);
  } 

 if (formErrors.value.length > 0 && submitStarted.value) {
    showFormErrorVergessen.value = true;
  } else {
    showFormErrorVergessen.value = false;
    submitStarted.value = false;
  }
 
}
// Validierungsfunktion
function validateForm() {
  // Validierung der Eingabefelder
  formErrors.value = [];
  const [showError, textError] = regexHelper.validateEmail(userLogin.value.user_email)
  
  if (showError) {
    formErrors.value.push(textError);
  } 
  if (userLogin.value.user_password.length < 6) {
    formErrors.value.push('Passwort muss mindestens 6 Zeichen lang sein');
  }
 if (formErrors.value.length > 0 && submitStarted.value) {
    showFormError.value = true;
  } else {
    showFormError.value = false;
    submitStarted.value = false;
  }
 
}

// Funktion, die prüft, ob es Fehler gibt
function hasErrors() {
 
  showFormError.value = Object.values(formErrors.value).some(error => error !== '')
  return Object.values(formErrors.value).some(error => error !== '')
  
}

// Login-Funktion
async function startLogin() {
  // Formular validieren
  submitStarted.value = true;
  validateForm()

  // Prüfen, ob es Fehler gibt
  if (hasErrors()) {
    console.log('Fehler im Formular, Login nicht möglich')
    return
  }

  // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
  console.log('Login wird gestartet...')
  // Ladezustand aktivieren
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");

  try {
    const response = await baseCalls.userPost(userLogin.value);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      userStore.setUser(response.data.user )
      loaderStore.setLoader(false);
      if (props.newRoute) {
            // Timeout von 1 Sekunde vor der Weiterleitung
          router.push(props.newRoute);
      }
    } else {
      errorStore.setError(true, 'Ihre Zugangsdaten sind scheinbar nicht korrekt');
    }
  } catch (err) {
   
    errorStore.setError(true, 'Ihre Zugangsdaten sind scheinbar nicht korrekt');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}


async function startPasswortVergessen() {

  submitStarted.value = true;
  validateFormVergessen()
    if (hasErrors()) {
      console.log('Fehler im Formular, Login nicht möglich')
      return
    }
  loaderStore.setLoader(true, "Bitte warten, Passwort wird zugesendet...");
  userLogin.value.action = 'passwortvergessen';
  try {
    const response = await baseCalls.userPost(userLogin.value);
    if (response.data.success ) {
      console.log('Passwort wurde zugesendet:', response.data);
      userLogin.value.user_email = '';
      userLogin.value.action = 'startlogin';
      loaderStore.setLoader(false);
      successStore.setSuccess(true, 'Passwort wurde zugesendet', 'Bitte überprüfen Sie Ihre E-Mail');
      userStore.setLoginView(false)
    
    } else {
      errorStore.setError(true, 'Ihre E-Mail ist  scheinbar nicht korrekt');
    }
  } catch (err) {
  
    errorStore.setError(true, 'Ihre E-Mail ist scheinbar nicht korrekt');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}
async function startLoginGoogle(payload) {
  // Formular validieren
  submitStarted.value = true;

  // Prüfen, ob es Fehler gibt
  let data = {
    user_email: payload.email,
    user_google_id: payload.sub,
    user_name: payload.name,
    action: 'startLoginGoogle'
  }

  // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
  console.log('google Login wird gestartet...', data) 
  // Ladezustand aktivieren
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");

  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      isLoggedIn.value = true;
      userStore.setUser(response.data.user )
      loaderStore.setLoader(false);
      if (props.newRoute) {
          // Timeout von 1 Sekunde vor der Weiterleitung
          router.push(props.newRoute);
      }
    } else {
      errorStore.setError(true, response.data.message);
    }
  } catch (err) {
   
    errorStore.setError(true, 'Es ist ein Fehler aufgetreten');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}

async function startLoginFacebook(payload) {
  // Formular validieren
  submitStarted.value = true;

  // Prüfen, ob es Fehler gibt
  let data = {
    user_email: payload.email,
    user_facebook_id: payload.id,
    user_name: payload.name,
    action: 'startLoginFacebook'
  }

  // Wenn keine Fehler vorhanden sind, Login-Logik ausführen
  console.log('Login wird gestartet...')
  // Ladezustand aktivieren
  loaderStore.setLoader(true, "Bitte warten, Sie werden eingeloggt...");

  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      isLoggedIn.value = true;
      userStore.setUser(response.data.user )
      loaderStore.setLoader(false);
      if (props.newRoute) {
          // Timeout von 1 Sekunde vor der Weiterleitung
          router.push(props.newRoute);
      }
    } else {
      errorStore.setError(true, response.data.message);
    }
  } catch (err) {
   
    errorStore.setError(true, 'Es ist ein Fehler aufgetreten');
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}

function loginWithGoogle() {
  countSocialLogins('google');
  console.log('Google Login gestartet');
  if (!googleInitialized || typeof google === 'undefined' || !google.accounts || !google.accounts.id) {
    console.log('googleInitialized',googleInitialized);
    console.log('google',google);
    console.log('google.accounts',google.accounts);
    console.log('google.accounts.id',google.accounts.id);
    errorStore.setError(true, 'Google-API ist nicht bereit oder konnte nicht geladen werden.');
    return;
  }

  google.accounts.id.prompt((notification) => {
    console.log('Google Login Notification:', notification);
    if (notification && notification.g) {
      const state = notification.g;
      const reason = notification.l;
      console.log(`Login Status: ${state}, Grund: ${reason}`);

      if (state === 'skipped') {
        if (reason === 'not_signed_in') {
          errorStore.setError(true, 'Sie sind nicht bei Google angemeldet. Bitte melden Sie sich zuerst in Ihrem Browser bei Google an und versuchen Sie es dann erneut.');
        } else if (reason === 'user_cancel' || reason === 'suppressed_by_user') {
          errorStore.setError(true, 'Sie haben den Google-Login abgebrochen.');
        } else if (reason === 'browser_not_supported') {
          errorStore.setError(true, 'Ihr Browser unterstützt den Google-Login nicht oder FedCM ist deaktiviert.');
        } else if (reason === 'unknown_reason' || !reason) {
          errorStore.setError(true, 'Bitte loggen Sie sich bei Google ein und versuchen Sie es erneut.');
        }
      } else if (state === 'dismissed') {
        errorStore.setError(true, 'Sie haben den Google-Login-Dialog geschlossen.');
      }
    } else if (notification && notification.error) {
        console.error("Google Prompt Error:", notification.error);
        errorStore.setError(true, `Fehler beim Google Login: ${notification.error.message || 'Unbekannter Fehler'}`);
    } else {
      console.warn("Unerwartete Google Login Notification Struktur:", notification);
      errorStore.setError(true, 'Ein unerwarteter Fehler ist beim Google-Login aufgetreten.');
    }
  });
}

function loginWithFacebook() {
  countSocialLogins('facebook');
  /* global FB */
  FB.login(function(response) {
    if (response.authResponse) {
      // Hier wird der Access Token aus der Antwort verwendet, 
      // ohne ihn global zu setzen
      const accessToken = response.authResponse.accessToken;
      
      FB.api('/me', { access_token: accessToken, fields: 'name,email' }, function(userData) {
        if(userData.id){
         
          console.log('Good to see you, ' + userData.name + '.');
          console.log(userData);
          startLoginFacebook(userData);
        }
       
        // Hier kannst du mit dem Benutzer und seinem Token arbeiten
      });
    } else {
      console.log('User cancelled login or did not fully authorize.');
    }
  }, { scope: 'public_profile,email' });
}

function handleGoogleCredentialResponse(response) {
  if (response.credential) {
    const googleData = parseJwt(response.credential);
    console.log('Google-Login erfolgreich:', googleData);
    startLoginGoogle(googleData);
  }
}

// JWT-Token dekodieren
function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    console.error('JWT dekodieren fehlgeschlagen', e);
    return null;
  }
}

let googleScriptLoaded = false;
let googleInitialized = false;

onMounted(() => {
  if (props.initialForgotPassword) {
    showPassVergessen.value = true;
  }
  // Facebook SDK initialisieren
  window.fbAsyncInit = function() {
    FB.init({
      appId: '563907036335909',
      cookie: true,
      xfbml: true,
      version: 'v12.0'
    });
  };

  // Facebook SDK laden
  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

  // Google-Login initialisieren
  if (!window.onGoogleLibraryLoad) {
    window.onGoogleLibraryLoad = () => {
      console.log("Google Library jetzt geladen, Initialisierung startet...");
      if (typeof google !== 'undefined' && google.accounts && google.accounts.id && !googleInitialized) {
        try {
          google.accounts.id.initialize({
            client_id: '342725743050-hm0bol77jhgirib5gbueqtvp919vr7f6.apps.googleusercontent.com',
            callback: handleGoogleCredentialResponse,
            use_fedcm_for_prompt: true
          });
          googleInitialized = true;
          console.log("Google Identity Services initialisiert mit FedCM.");
        } catch (e) {
          console.error("Fehler bei der Initialisierung von Google Identity Services:", e);
        }
      } else if (googleInitialized) {
        console.log("Google Identity Services bereits initialisiert.");
      } else {
        console.error("Google-Objekt nicht verfügbar nach Skript-Ladung für Initialisierung.");
      }
    };
  }

  // Lade das Google-Skript, falls noch nicht geschehen
  loadGoogleScript();
});

function loadGoogleScript() {
  if (document.getElementById('google-script')) {
    console.log("Google-Skript-Tag existiert bereits.");
    if (typeof window.onGoogleLibraryLoad === 'function' && !googleInitialized) {
        console.log("Versuche onGoogleLibraryLoad manuell aufzurufen, da Skript schon da, aber nicht initialisiert.");
        window.onGoogleLibraryLoad();
    }
    return;
  }

  if (googleScriptLoaded) {
    console.log("Google-Skript-Ladeprozess bereits gestartet.");
    return;
  }

  console.log("Google-Skript wird geladen...");
  googleScriptLoaded = true;
  const script = document.createElement('script');
  script.id = 'google-script';
  script.src = 'https://accounts.google.com/gsi/client?v=latest';
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}

</script>

<style>
.error {
  color: red;
  font-size: 0.9em;
}
.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.divider-text {
  padding: 0 16px;
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
</style>
